import axios from "axios";

export const admin_tp_locations_state_mixin = (is_current_admin = true) => ({
  data() {
    return {
      tp_locations: {},
      is_tp_locations_loaded: false,
      tp_locations_refresh_interval_instance: null
    };
  },
  computed: {
    is_tp_service_account_connected() {
      return location_type => {
        if (
          location_type !== "zoom_meeting" &&
          location_type !== "gotomeeting_meeting" &&
          location_type !== "googlemeet_meeting"
        ) {
          return null;
        }
        if (!this.is_tp_locations_loaded) {
          return true; //till loading - to avoid showing accounts not connected
        }
        if (this.tp_locations.hasOwnProperty(location_type)) {
          return this.tp_locations[location_type].is_connected;
        }
        return false;
      };
    },
    googlemeet_meeting_is_account_connected() {
      if (this.tp_locations.hasOwnProperty("googlemeet_meeting")) {
        return this.tp_locations["googlemeet_meeting"].is_connected_and_active;
      }
      return null;
    },
    googlemeet_meeting_account_email() {
      return this.tp_locations &&
        this.tp_locations.googlemeet_meeting &&
        this.tp_locations.googlemeet_meeting.account_email
        ? this.tp_locations.googlemeet_meeting.account_email
        : "";
    }
  },
  methods: {
    load_tp_locations_by_admin(background = false) {
      let wpcal_request = {};
      let action = "";
      if (is_current_admin) {
        action = "get_tp_locations_details_for_current_admin";
        wpcal_request[action] = "dummy__";
      } else if (
        !is_current_admin &&
        this.tp_locations_required_admin_user_id
      ) {
        action = "get_tp_locations_details_by_admin";
        wpcal_request[action] = {
          admin_user_id: this.tp_locations_required_admin_user_id
        };
      } else {
        return;
      }

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      let axios_options = {};
      if (background) {
        axios_options = {
          params: { _remove_options_before_call: { background_call: true } }
        };
      }

      axios
        .post(window.wpcal_ajax.ajax_url, post_data, axios_options)
        .then(response => {
          if (
            response.data &&
            response.data[action].hasOwnProperty("tp_locations")
          ) {
            // for (let key in response.data[action].tp_locations) {
            //   console.log(key, response.data[action].tp_locations[key]);
            //   this.$set(
            //     this.tp_locations,
            //     key,
            //     response.data[action].tp_locations[key]
            //   );
            // }
            this.tp_locations = response.data[action].tp_locations;
          }
          this.is_tp_locations_loaded = true;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    setTimeout(() => {
      this.load_tp_locations_by_admin();
      let tp_locations_refresh_interval_instance = setInterval(() => {
        if (document.hasFocus()) {
          this.load_tp_locations_by_admin(true);
        }
      }, 5000);
      this.$store.commit(
        "set_tp_locations_refresh_interval_instance",
        tp_locations_refresh_interval_instance
      );
      //using Vuex instead of this.tp_locations_refresh_interval_instance because it is not updating properly, when this code wrapped with setTimeout sometimes 700 ms it works, better use Vuex
    }, 100);
  },
  beforeDestroy() {
    clearInterval(
      this.$store.getters.get_tp_locations_refresh_interval_instance
    );
    this.$store.commit("set_tp_locations_refresh_interval_instance", null);
  }
});
